export const ADMIN_ONLY_MESSAGE = "Only admin users can access this app.";
export const ADMIN_APP_AUTHORIZED_KEY = "adminAppAuthorized";

const ADMIN_ROLE_VALUES = new Set(["admin", "administrator", "super_admin", "superadmin"]);

const isTruthyAdminFlag = (value: unknown) =>
  value === true || value === 1 || value === "true" || value === "1";

const normalizeRole = (value: unknown) =>
  typeof value === "string" ? value.trim().toLowerCase() : "";

const hasAdminRole = (value: unknown): boolean => {
  if (Array.isArray(value)) {
    return value.some((item) => {
      if (typeof item === "string") return ADMIN_ROLE_VALUES.has(normalizeRole(item));
      return (
        ADMIN_ROLE_VALUES.has(normalizeRole(item?.name)) ||
        ADMIN_ROLE_VALUES.has(normalizeRole(item?.role))
      );
    });
  }

  return ADMIN_ROLE_VALUES.has(normalizeRole(value));
};

export const isAdminUser = (user: any): boolean => {
  if (!user) return false;

  if (user.data && user.data !== user) {
    return isAdminUser(user.data);
  }

  if (
    isTruthyAdminFlag(user[ADMIN_APP_AUTHORIZED_KEY]) ||
    isTruthyAdminFlag(user.isAdmin) ||
    isTruthyAdminFlag(user.admin) ||
    isTruthyAdminFlag(user.isSuperAdmin) ||
    isTruthyAdminFlag(user.superAdmin)
  ) {
    return true;
  }

  return (
    hasAdminRole(user.role) ||
    hasAdminRole(user.roles) ||
    hasAdminRole(user.userRole) ||
    hasAdminRole(user.userType) ||
    hasAdminRole(user.type)
  );
};
